module.exports = __webpack_public_path__ + "static/media/IMG-5136.e51cd51a.jpg";